<template>
  <div :style="style.container">
    <div :style="style.text">
      Skills gap: {{ missedSkillsRatio }}%
    </div>
    <div :style="style.barContainer">
      <div :style="getLeftBarStyle" />
      <div :style="getRightBarStyle" />
    </div>
  </div>
</template>

<script>
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SkillsGap',
    props: {
      missedSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
      requiredSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data: function () {
      return {
        style: {
          barContainer: {
            display: 'flex',
            flex: 1,
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            height: '42px',
            width: '100%',
          },
          text: {
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.lg,
            padding: `0 ${Layout.space.sm} 0 0`,
          },
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getLeftBarStyle: function () {
        return {
          backgroundColor: this.color.unavailable(),
          borderRadius: this.missedSkillsRatio === 100 ? Layout.space.xs : `${Layout.space.xs} 0 0 ${Layout.space.xs}`,
          height: Layout.space.xs,
          width: `${this.missedSkillsRatio}%`,
        };
      },
      getRightBarStyle: function () {
        return {
          backgroundColor: this.color.dark5(),
          borderRadius: this.requiredSkillNotRegistered ? Layout.space.xs : `0 ${Layout.space.xs} ${Layout.space.xs} 0`,
          height: Layout.space.xs,
          width: `${100 - this.missedSkillsRatio}%`,
        };
      },
      missedSkillsRatio: function () {
        return this.requiredSkillNotRegistered ? 0 : parseInt(this.missedSkills.length / this.requiredSkills.length * 100);
      },
      requiredSkillNotRegistered: function () {
        return this.requiredSkills.length === 0;
      },
    },
  };
</script>
